import { DefaultLayout } from '@s/layouts/DefaultLayout';
import { GatsbyBrowser } from 'gatsby';

export const wrapPageElement: GatsbyBrowser['wrapPageElement'] = ({ element, props }) => (
    <DefaultLayout {...props}>{element}</DefaultLayout>
);
